import { NOT_FOUND } from "redux-first-router";
import {
  ROUTE_MANAGE_CONNECTIONS,
  ROUTE_AUTH,
  ROUTE_HOME,
  ROUTE_FORBIDDEN,
  ROUTE_ADVERTISER,
  ROUTE_EXAMPLE_TAKEOVER,
  ROUTE_EXAMPLE_TABS,
  ROUTE_ADVERTISER_DETAIL,
  ROUTE_ADVERTISER_EDIT,
  ROUTE_GA_INVITE,
  ROUTE_ADVERTISER_TABS,
  ROUTE_CAMPAIGN_TABS,
  ROUTE_ADMIN_SETTINGS,
  ROUTE_NO_PERMISSON,
  ROUTE_NO_ADMIN_PERMISSION,
  ROUTE_EXPORT_PDF,
  ROUTE_EXPORT_CUSTOM_REPORT,
  ROUTE_CAMPAIGN,
  ROUTE_CAMPAIGN_DETAIL,
  ROUTE_CAMPAIGN_EDIT,
  ROUTE_CAMPAIGN_ERROR_PAGE,
  ROUTE_ADVERTISER_EDIT_TAB,
  ROUTE_DRILLDOWN,
  ROUTE_CAMPAIGN_EDIT_TAB,
  ROUTE_USER_MANAGEMENT,
  ROUTE_PLAYOUT_DATA,
  ROUTE_PLAYOUT_DATA_MAPPING,
  ROUTE_PLAYOUT_UPLOADS,
  ROUTE_PLAYOUT_LOADER,
  ROUTE_PLAYOUT_ERROR_REPORT,
  ROUTE_PLAYOUT_DRILLDOWN,
  ROUTE_CREATE_REPORT,
  ROUTE_DEMO_SCHEDULE_REPORT,
  ROUTE_UNSUBSCRIBE_REPORT,
  ROUTE_CUSTOMIZED_PDF_REPORT,
  ROUTE_CUSTOMIZED_PPTX_REPORT,
  ROUTE_UNSUBSCRIBE_EMAIL,
} from "modules/routing";
import { ADVERTISER_DASHBOARD_ROUTES } from '../src/helpers/constant';

import { loadAuthPage, loadPermissionPage } from "modules/auth/saga";
import { loadExampleTabsPage } from "modules/exampleTabs/saga";
import get from 'lodash/get';

export default {
  [ROUTE_AUTH]: {
    path: "/login",
    component: "Auth",
    saga: loadAuthPage,
    requiresAuth: false
  },
  [ROUTE_HOME]: {
    path: "/",
    component: "Home",
        requiresAuth: true
    },
  [ROUTE_MANAGE_CONNECTIONS]: {
      path: "/connections",
      component: "NewManageConnections",
  requiresAuth: true
  },
  [ROUTE_NO_PERMISSON]: {
    path: "/",
    component: "NoPermission",
    requiresAuth: true
  },
  [ROUTE_NO_ADMIN_PERMISSION]: {
    path: "/permission-denied",
    component: "NoAdminPermission",
    requiresAuth: true
  },
  [ROUTE_ADVERTISER]: {
    path: "/advertiser/new",
    modalOver: ROUTE_HOME,
    component: "Advertiser",
    requiresAuth: true
  },
  [ROUTE_CAMPAIGN]: {
    path: "/campaign/new",
    modalOver: ROUTE_HOME,
    component: "CampaignWrapper",
    requiresAuth: true
  },
  [ROUTE_CAMPAIGN_ERROR_PAGE]: {
    path: "/advertiser/:advertiserId/campaign/:campaignId/error",
    modalOver: ROUTE_CAMPAIGN_DETAIL,
    component: "CampaignErrorPage",
    requiresAuth: true
  },
  [ROUTE_ADVERTISER_DETAIL]: {
    path: "/advertiser/:advertiserId",
    modalOver: ROUTE_HOME,
    component: "Home",
    requiresAuth: true
  },
  [ROUTE_ADVERTISER_EDIT_TAB]: {
    path: "/advertiser/:advertiserId/edit/:tab",
    modalOver: ROUTE_HOME,
    component: "Advertiser",
    requiresAuth: true
  },
  [ROUTE_CAMPAIGN_DETAIL]: {
    path: "/advertiser/:advertiserId/campaign/:campaignId",
    modalOver: ROUTE_HOME,
    component: "Home",
    requiresAuth: true
  },
  [ROUTE_CAMPAIGN_EDIT]: {
    path: "/campaign/:campaignId/edit",
    modalOver: "Home",
    component: "CampaignWrapper",
    requiresAuth: true
  },
  [ROUTE_ADVERTISER_EDIT]: {
    path: "/advertiser/:advertiserId/edit",
    modalOver: ROUTE_HOME,
    component: "Advertiser",
    requiresAuth: true
  },
  [ROUTE_ADVERTISER_TABS]: {
    path: "/advertiser/:advertiserId/:tab?",
    component: "Home",
    requiresAuth: true,
    redirects: [
      {
        test: (getState, action ) => !ADVERTISER_DASHBOARD_ROUTES.includes(action.payload.tab),
        to: { type: NOT_FOUND }
      }
    ]
  },
  [ROUTE_CAMPAIGN_TABS]: {
    path: "/advertiser/:advertiserId/campaign/:campaignId/:tab?",
    component: "Home",
    requiresAuth: true
  },
  [ROUTE_DRILLDOWN]: {
    path: "/advertiser/:advertiserId/campaign/:campaignId/:tab/:drilldown",
    component: "Home",
    requiresAuth: true
  },
  [ROUTE_EXAMPLE_TAKEOVER]: {
    path: "/example-takeover",
    modalOver: ROUTE_HOME,
    component: "ExampleTakeoverModal",
    requiresAuth: true
  },
  [ROUTE_ADMIN_SETTINGS]: {
    path: "/config/:tab?",
    component: "AdminSettings",
    requiresAuth: true,
    saga: loadPermissionPage
  },
  [ROUTE_EXPORT_PDF]: {
    path: "/export-pdf",
    component: "ExportPDF",
    requiresAuth: false
  },
  [ROUTE_EXPORT_CUSTOM_REPORT]: {
    path: "/export-custom-pdf",
    component: "ExportCustomPDF",
    requiresAuth: false,
  },
  [ROUTE_EXAMPLE_TABS]: {
    path: "/tabs/:tab?",
    component: "ExampleTabs",
    requiresAuth: true,
    saga: loadExampleTabsPage,
    redirects: [
      {
        test: (getState, action) =>
          // /tabs or /tabs/invalidTab
          !["categories", "tasks"].includes(action.payload.tab),
        to: {
          type: ROUTE_EXAMPLE_TABS,
          payload: { tab: "categories" }
        }
      }
    ]
  },
  design: {
    path: "/design",
    component: "Design",
    requiresAuth: false
  },
  [NOT_FOUND]: {
    path: "/not-found",
    component: "NotFound",
    requiresAuth: true
  },
  [ROUTE_FORBIDDEN]: {
    path: "/forbidden",
    component: "Forbidden",
    requiresAuth: true
  },
  [ROUTE_GA_INVITE]: {
    path: "/ga-invite/:tokenId",
    component: "GAInvite",
    requiresAuth: false
  },
  [ROUTE_USER_MANAGEMENT]: {
    path: '/user_management/:tab?',
    component: 'UserManagement',
    requiresAuth: true
  },
  [ROUTE_PLAYOUT_DATA]: {
    path: '/playout',
    component: 'PlayoutDataManagement',
    requiresAuth: true
  },
  [ROUTE_PLAYOUT_UPLOADS]: {
    path: '/playout/uploads',
    component: 'PlayoutUploadHistory',
    requiresAuth: true
  },
  [ROUTE_PLAYOUT_DATA_MAPPING]: {
    path: '/playout/import',
    component: 'PlayoutImportFile',
    requiresAuth: true,
    redirects: [
      {
        test: (getState) => {
          const state = getState();
          const currentUploadFileRef = get(state, 'playout.currentUploadFile.ref');
          return !currentUploadFileRef;
        },
        to: {
          type: ROUTE_PLAYOUT_DATA
        }
      }
    ]
  },
  [ROUTE_PLAYOUT_LOADER]: {
    path: '/playout/browse',
    component: 'PlayoutImportFile',
    requiresAuth: true
  },
  [ROUTE_PLAYOUT_ERROR_REPORT]: {
    path: '/playout/:fileId/errors',
    component: 'PlayoutErrorReport',
    requiresAuth: true
  },
  [ROUTE_PLAYOUT_DRILLDOWN]: {
    path: '/playout/:fileId/drilldown',
    component: 'PlayoutDrilldown',
    requiresAuth: true
  },
  [ROUTE_CREATE_REPORT]: {
    path: '/create_report/advertiser/:advertiserId/campaign/:campaignId/report/:reportId/:tab?/:step?',
    component: 'ReportBuilder',
    requiresAuth: true,
  },
  [ROUTE_DEMO_SCHEDULE_REPORT]: {
    path: '/demo_schedule_report',
    component: 'ScheduleReport',
    requiresAuth: true,
  },
  [ROUTE_UNSUBSCRIBE_REPORT]: {
    path: '/schedule-report/unsubscribe/:subscriberToken?',
    component: 'UnsubscribeReport',
    requiresAuth: false,
  },
  [ROUTE_CUSTOMIZED_PDF_REPORT]: {
    path: '/report-builder/pdf',
    component: 'PdfReportBuilder',
    requiresAuth: false,
  },
  [ROUTE_CUSTOMIZED_PPTX_REPORT]: {
    path: '/report-builder/pptx',
    component: 'PPTXReportBuilder',
    requiresAuth: false,
  },
  [ROUTE_UNSUBSCRIBE_EMAIL]: {
    path: '/unsubscribe/:subscriberToken?',
    component: 'UnsubscribeEmail',
    requiresAuth: false,
  },
};
